/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function certificationRequirements(instance) {
	return {
		/**
		 * @param {number} season
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (season, filters = [], config = {}) => {
			let endpoint = `retailers/programmes/table?season=${season}`
			filters.forEach((filter) => {
				endpoint += `&${filter.key}=${filter.value}`
			})

			return instance.get(endpoint, config)
		},

		/**
		 * @param {number} season
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getHeaderTable: (season, config = {}) => {
			return instance.get(
				`retailers/programmes/header?season=${season}`,
				config
			)
		},

		/**
		 * @param {number} season
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (body, config = {}) => {
			return instance.put(`retailers/programmes/table`, body, config)
		}
	}
}
